import React from "react";
import { Link } from "react-router-dom";
import { User, MessageSquare, ArrowRight } from "lucide-react";
import { blog } from "../mock";
import { SectionLabel, Reveal } from "../components/common";

export const BlogCard = ({ b }) => (
  <div className="group bg-white rounded-lg overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-shadow">
    <div className="relative overflow-hidden">
      <img
        src={b.img}
        alt={b.title}
        className="w-full h-[240px] object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute top-4 left-4 bg-[#CD0008] text-white text-center rounded-md px-4 py-2">
        <span className="block display-heading text-2xl leading-none">{b.day}</span>
        <span className="block text-xs uppercase">{b.month}</span>
      </div>
    </div>
    <div className="p-7">
      <div className="flex items-center gap-5 text-xs text-gray-500 mb-4">
        <span className="flex items-center gap-1.5"><User size={14} className="text-[#CD0008]" /> {b.author}</span>
        <span className="flex items-center gap-1.5"><MessageSquare size={14} className="text-[#CD0008]" /> Comments ({b.comments})</span>
      </div>
      <h3 className="font-display font-bold text-[#0B102D] text-xl leading-snug mb-4 group-hover:text-[#CD0008] transition-colors">
        {b.title}
      </h3>
      <p className="text-gray-500 text-sm leading-relaxed mb-5">{b.excerpt}</p>
      <Link to="/news" className="inline-flex items-center gap-2 font-display font-semibold text-sm uppercase tracking-wide text-[#0B102D] hover:text-[#CD0008] transition-colors">
        Learn More <ArrowRight size={16} />
      </Link>
    </div>
  </div>
);

const Blog = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1320px] mx-auto px-5">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex justify-center"><SectionLabel>Our Blog</SectionLabel></div>
          <h2 className="section-heading text-[#0B102D] text-4xl md:text-5xl">Latest news &amp; insight</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-7">
          {blog.map((b, i) => (
            <Reveal key={b.id} direction="up" delay={i * 120}>
              <BlogCard b={b} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
